module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "company-select"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': _vm.company.initials === null
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.setCompany(null)
      }
    }
  }, [_vm._v("All Companies")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.company.initials === 'CF'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.setCompany('CF')
      }
    }
  }, [_vm._v("\n            Crockett Farms\n            "), (_vm.cfOrders.length > 0) ? _c('span', [_vm._v("\n                               \n                              "), _c('span', {
    staticClass: "tag is-rounded is-danger"
  }, [_vm._v(_vm._s(_vm.cfOrders.length))])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.company.initials === 'BELLS'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.setCompany('BELLS')
      }
    }
  }, [_vm._v("\n            Bells Farm To Market\n            "), (_vm.bellsOrders.length > 0) ? _c('span', [_vm._v("\n                               \n                              "), _c('span', {
    staticClass: "tag is-rounded is-danger"
  }, [_vm._v(_vm._s(_vm.bellsOrders.length))])]) : _vm._e()])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar is-dark",
    attrs: {
      "role": "navigation",
      "aria-label": "dropdown navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v("\n         \n        Dashboard (" + _vm._s(_vm.admin.first_name) + ")\n      ")]), _vm._v(" "), _c('span', {
    class: {
      'navbar-burger burger': true, 'is-active': _vm.showNavMenu
    },
    on: {
      "click": function($event) {
        _vm.showNavMenu = !_vm.showNavMenu
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    class: {
      'navbar-menu': true, 'is-active': _vm.showNavMenu
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'orders'
      }
    }
  }, [_vm._v("Orders")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'requests'
      }
    }
  }, [_vm._v("Mailing")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("Users")]), _vm._v(" "), (_vm.isSuperUser) ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'products'
      }
    }
  }, [_vm._v("\n          Product Management\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isSuperUser) ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'pages'
      }
    }
  }, [_vm._v("\n          Pages\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isSuperUser) ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'images'
      }
    }
  }, [_vm._v("\n          Images\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isSuperUser) ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'admins'
      }
    }
  }, [_vm._v("\n          Admins\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isSuperUser) ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'reports'
      }
    }
  }, [_vm._v("\n          Reports\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "navbar-item"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('span', [_vm._v("Logout")]), _vm._v(" "), _vm._m(0)])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77af2a20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/Header.vue
// module id = 557
// module chunks = 0